export default ({ message, secondaryMessage, type = "error" }) => dispatch => {
    dispatch({
        type: 'SHOW_SNACKBAR_MESSAGE',
        payload: { message, type, secondaryMessage }
    })
}